import type { FC } from 'react';
import { useState, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DescriptionEditor from '@wix/da-shared-react/pkg/DescriptionEditor';
import { BatchActionProps } from '../types';
import MobileBatchActionWrapper from '../MobileBatchActionWrapper';
import DesktopBatchActionWrapper from '../DesktopBatchActionWrapper';
import { EditorApi } from '@wix/da-editor-tiptap/pkg/components/Editor/types';

import s from './DescriptionBatchEdit.scss';

export interface Props extends BatchActionProps {
  batchEditDescription: (newState) => void;
}

const DescriptionBatchEdit: FC<Props> = ({ batchEditDescription, selectionArea }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const [editorApi, setEditorApi] = useState<EditorApi | null>(null);

  const handleSave = useCallback(() => {
    if (editorApi) {
      batchEditDescription(editorApi.getStateForSave() as any);
    }
  }, [batchEditDescription, editorApi]);

  const handleInitialContentReady = useCallback(api => {
    setEditorApi(api);
  }, []);

  const form = (
    <div>
      <DescriptionEditor
        className={s['editor']}
        placeholder={t('studio.batchActions.form.edit_description.placeholder')}
        onInitialContentReady={handleInitialContentReady}
      />
    </div>
  );

  if (isMobile) {
    return (
      <MobileBatchActionWrapper
        heading={t('studio.batchActions.subtitle.edit_description')}
        onSave={handleSave}
        restrictSave="non_core_multiple"
      >
        {form}
      </MobileBatchActionWrapper>
    );
  }

  return (
    <DesktopBatchActionWrapper
      heading={t('studio.batchActions.subtitle.edit_description')}
      selectionArea={selectionArea}
      onSave={handleSave}
      restrictSave="non_core_multiple"
    >
      {form}
    </DesktopBatchActionWrapper>
  );
};
DescriptionBatchEdit.displayName = 'DescriptionBatchEdit';

export default DescriptionBatchEdit;
